export function frameAt(track, currentSec) {
    const verseIdx = findVerseIndex(track.verses, currentSec);
    const currentVerse = verseIdx === -1 ? null : (track.verses[verseIdx] ?? null);
    const verseProgress = currentVerse ? progressIn(currentVerse, currentSec) : 0;
    let currentWord = null;
    if (track.words) {
        const wordIdx = findCueIndex(track.words, currentSec);
        if (wordIdx !== -1)
            currentWord = track.words[wordIdx] ?? null;
    }
    return {
        currentVerseIndex: verseIdx === -1 ? null : verseIdx,
        currentVerse,
        verseProgress,
        currentWord,
    };
}
/**
 * Binary search for the verse cue active at time `t`.
 * Returns the cue index when `beginSec <= t < endSec`.
 * When `t` is past a cue's endSec, holds the last cue whose beginSec <= t —
 * this keeps the verse highlight alive through inter-verse gaps and closing
 * audio rather than flashing to "nothing highlighted".
 * Returns -1 only when `t` is before the very first cue (preamble audio).
 */
function findVerseIndex(cues, t) {
    let lo = 0;
    let hi = cues.length - 1;
    let lastBeforeT = -1;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        const cue = cues[mid];
        if (!cue)
            break;
        if (t < cue.beginSec) {
            hi = mid - 1;
        }
        else {
            lastBeforeT = mid;
            if (t < cue.endSec)
                return mid;
            lo = mid + 1;
        }
    }
    return lastBeforeT;
}
/**
 * Strict binary search: returns the cue index where `beginSec <= t < endSec`,
 * or -1 for any gap or out-of-range position. Used for word-level timing where
 * holding the last word after it ends would be incorrect.
 */
function findCueIndex(cues, t) {
    let lo = 0;
    let hi = cues.length - 1;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        const cue = cues[mid];
        if (!cue)
            return -1;
        if (t < cue.beginSec)
            hi = mid - 1;
        else if (t >= cue.endSec)
            lo = mid + 1;
        else
            return mid;
    }
    return -1;
}
function progressIn(cue, t) {
    const span = cue.endSec - cue.beginSec;
    if (span <= 0)
        return 0;
    return Math.max(0, Math.min(1, (t - cue.beginSec) / span));
}
//# sourceMappingURL=karaoke.js.map